
class ConciergeServicesApi {
  getConciergeServices() {
    const services = [
      {
        id: 11,
        image: '/static/frontend/mixingboard.jpeg',
      },
      {
        id: 12,
        image: '/static/frontend/typinglaptop.jpeg',
      },
      {
        id: 13,
        image: '/static/frontend/playingguitar.jpeg',
      },
      {
        id: 14,
        image: '/static/frontend/studiomic.jpeg',
      },
      {
        id: 15,
        image: '/static/frontend/typingscript.jpeg',
      },
      {
        id: 16,
        image: '/static/frontend/videoediting.jpeg',
      },
    ]
    return Promise.resolve(services);
  }
}

export const conciergeServicesApi = new ConciergeServicesApi();